/** Change quantity custom input */
jQuery(document).on("click", ".quantity__plus", function(e) {
  const input = jQuery(this)
    .closest(".quantity")
    .find("input.qty");

  var val = parseInt(input.val());
  var step = parseInt(input.attr("step")) || 1;

  input.val(val + step).change();
  jQuery('input[name="update_cart"]').trigger("click");
});
jQuery(document).on("click", ".quantity__minus", function(e) {
  const input = jQuery(this)
    .closest(".quantity")
    .find("input.qty");

  var val = parseInt(input.val());
  var step = parseInt(input.attr("step")) || 1;

  if (val > step) {
    input.val(val - step).change();
    jQuery('input[name="update_cart"]').trigger("click");
  } else {
    input.val(step).change();
    jQuery('input[name="update_cart"]').trigger("click");
  }
});
/** End Change quantity custom input */

/** ------------------------------------ */

/** Change price on variation product */
jQuery(document.body).bind("found_variation", (e, variation) => {
  // const defaultPrice = jQuery(".price-original").html();

  if (!variation.price_html) {
    // jQuery(".price-original").show();
    return;
  }

  jQuery(".price-original").fadeOut(100, () => {
    jQuery(".price-selected")
      .html(variation.price_html)
      .fadeIn(100);
  });
});

jQuery(document.body).bind("reset_data", () => {
  jQuery(".price-selected").fadeOut(100, () => {
    jQuery(".price-original").fadeIn(100);
  });
});
/** End Change price on variation product */
